import { BankAccount, Class } from '@/plugins/api'
import { rangeRight } from 'lodash-es'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    bankAccounts: [],
    classBankAccount: {},
    totalItems: 0,
    classSearchParams: {},
    itemsPerPage: 10,
    pageText: '',
    loading: false,
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.classSearchParams) {
        const classSearchParams = { ...state.classSearchParams, type: 'coreCurriculum' }
        const [totalItems, bankAccounts] = await Promise.all([
          Class.count(classSearchParams),
          BankAccount.findTuitionBankAccounts({
            ...classSearchParams,
            _start: (page - 1) * itemsPerPage,
            _limit: itemsPerPage,
          }),
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            bankAccounts,
            totalItems,
            itemsPerPage,
            classSearchParams,
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('changeState', { pageText })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async searchClasses({ commit, state, dispatch }, query) {
      const classSearchParams = {
        _limit: state.itemsPerPage,
        ...query,
      }
      commit('changeState', { classSearchParams })
      dispatch('requestPageSettings', {})
    },
    async fetchBankAccount(_, query) {
      let bankAccounts = await BankAccount.fetch(query)
      return bankAccounts.length ? bankAccounts[0] : null
    },
    async fetchOneBankAccount({ commit }, query) {
      const oneClass = await Class.search(query)
      let params = {
        class: oneClass[0].id,
      }
      let bankAccount = await BankAccount.search(params)
      if (bankAccount) {
        oneClass[0].bankAccount = bankAccount[0]
      }
      commit('changeState', { classBankAccount: oneClass[0] })
    },
    async create({ dispatch }, data) {
      try {
        await BankAccount.create(data)
        dispatch('requestPageSettings', {})
        alert.updateSuccess('tài khoản ngân hàng')
      } catch (err) {
        alert.addError(err)
      }
    },
    async update({ commit, dispatch }, { id, params }) {
      try {
        const res = await BankAccount.update(id, params)
        commit('changeState', { classBankAccount: res })
        dispatch('requestPageSettings', {})
        alert.updateSuccess('tài khoản ngân hàng')
      } catch (err) {
        alert.updateError(err)
      }
    },
    async fetchPeriods({ commit, state }) {
      state.loading = true
      let bankAccounts = await BankAccount.fetch()
      commit('changeState', { bankAccounts })
      state.loading = false
    },
  },
  mutations: {
    setPeriods(state, periods) {
      state.periods = periods
    },
    setPeriod(state, period) {
      state.period = period
    },
  },
  getters: {
    bankAccounts: (state) => state.bankAccounts,
    classBankAccount: (state) => state.classBankAccount,
    loading: (state) => state.loading,
    pageText: (state) => state.pageText,
    totalItems: (state) => state.totalItems,
  },
}
